import { render, staticRenderFns } from "./RolesDrawerFooter.vue?vue&type=template&id=1ff05a78&scoped=true&"
import script from "./RolesDrawerFooter.vue?vue&type=script&lang=js&"
export * from "./RolesDrawerFooter.vue?vue&type=script&lang=js&"
import style0 from "./RolesDrawerFooter.vue?vue&type=style&index=0&id=1ff05a78&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff05a78",
  null
  
)

export default component.exports